import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
const OAUTH_ENDPOINT = '/authorizationserver/oauth/token';
@Injectable({ providedIn: 'root' })
export class KbHttpErrorInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((errResponse: HttpErrorResponse) => {
        if (
          errResponse.url?.includes(OAUTH_ENDPOINT) &&
          request.body?.get('grant_type') === 'password' &&
          errResponse.error?.error === 'invalid_grant' &&
          errResponse instanceof HttpErrorResponse &&
          errResponse.error.error_description !== 'Bad credentials'
        ) {
          const error = {
            error: 'invalid_grant',
            error_description: 'User is disabled',
          };
          throw new HttpErrorResponse({
            ...errResponse,
            error,
          });
        } else {
          throw errResponse;
        }
      })
    );
  }
}
